<template>
	<v-tooltip top>
		<template v-slot:activator="{ on, attrs }">
			<v-hover v-slot="{ hover }" open-delay="5" close-delay="5">
				<v-btn
					@click="$emit('multitaskClick')"
					v-bind="attrs"
					v-on="on"
					class="square d-flex align-center justify-center"
					:style="{
						background: hover ? iconColor : backgroundColor,
					}"
					x-small
					icon
					:disabled="active"
				>
					<v-icon :color="hover ? backgroundColor : iconColor">
						<slot></slot>
					</v-icon>
				</v-btn>
			</v-hover>
		</template>
		<span>{{ tooltipName }}</span>
	</v-tooltip>
</template>

<script>
export default {
	props: {
		tooltipName: String,
		backgroundColor: String,
		iconColor: String,
		active: Boolean,
	},
};
</script>

<style lang="scss" scoped>
.square {
	width: 32px;
	height: 32px;
	border-radius: 8px;
}
</style>
